// Lib
import { KPI_VALUE_PERCENT } from '@/hooks/format/useFormatKpiValue';

import { colors } from '@/lib/analytics/colors';
// Types
import type { KpiType } from '@/lib/analytics/kpis/kpi.type';
import { ORIENTATION_VERTICAL } from '@/lib/gridElements/orientation';
import { SIZE_50 } from '@/lib/gridElements/size';

// Components
import { MediaViewerKpiLoader } from '@/components/base/Kpi/KpiLoader';

export const mediaViewerImpressionRateConfig: KpiType<typeof MediaViewerKpiLoader> = {
    name: 'kpi.pinterest.impression_rate',
    id: 'impression_rate',
    icon: {
        name: 'impressions',
        style: colors.purple
    },
    data_format: KPI_VALUE_PERCENT,
    size: SIZE_50,
    orientation: ORIENTATION_VERTICAL,
    type: 'kpi',
    loader: MediaViewerKpiLoader
};
